import { COMPONENT_SOURCE_TEMPLATES, EXPOSED_SYMBOLS } from '@aeppic/dynamic-components-v3'
import DynamicComponent from '../dynamic/dynamic-component'
import createEventForwarders from '../utils/create-event-forwarders'
import { isDocument } from '../../model/is'
import { perf } from '../perf.js'

export default {
  /* tslint:disable */
  render () {
    const _vm=this;
    const _h=_vm.$createElement;
    const _c=_vm._self._c||_h;
    
    return _vm.canRender ? _c(_vm.dynamicComponent.id,
        {
          tag: 'component',
          key: _vm.renderedComponentKey,
          style: _vm.isComponentManuallyHidden ? { display: 'none' } : undefined,
          props: {
            'Aeppic': _vm.Aeppic,
            'linked-document': _vm.documentToBeRendered,
            'document-edit-version': _vm.renderedDocumentEditVersion,
            'design': _vm.dynamicComponent.document,
            'edit': _vm.edit,
            'params': _vm.dynamicParams,
            'hide-component': _vm.hideComponent,
            'show-component': _vm.showComponent,
            'is-component-hidden': _vm.isComponentManuallyHidden,
          },
          on: createEventForwarders(_vm._events, _vm)
        }) : _vm.renderFallback(_h)
  },
  renderError(h, err) {
    return h('pre', { staticClass: 'ae-error', style: { color: 'red' }}, 'ae-design:' + this.name + ' for ' + this.documentToBeRendered.id + '' + ' ' +  err.stack)
  },
  staticRenderFns: [],
  /* tslint:enable */
  
  inject: ['getAeppicContext'],
  props: {
    name: {
      type: String,
      required: true
    },
    params: Object,
    documentId: String,
    document: Object,
    edit: {
      type: Boolean,
      default: false
    },
    watch: {
      type: Boolean,
      default: true
    },
    watchDesign: {
      type: Boolean,
      default: null
    },
    watchDesignRevisions: {
      type: Boolean,
      default: null
    },
    missingDocLayoutId: String,
  },
  data() {
    const Aeppic = this.getAeppicContext('ae-design-selector', this.documentId ?? this.document)
    
    return {
      Aeppic,
      dynamicComponent: null,
      documentToBeRendered: null,
      loadedDocument: null,
      renderedDocumentEditVersion: null,
      editContextWatcher: null,
      routeParamsFromHistory: null,
      fallbackDesign: null,
      isComponentManuallyHidden: false,
      fallbackReason: 'loading',
    }
  },
  computed: {
    dynamicParams() {
      if (!this.routeParamsFromHistory) {
        return this.params
      }

      const params = this.params || {}
      const route = params.route || {}

      return {
        ...params,
        route: {
          ...route,
          query: this.routeParamsFromHistory.query,
          subpath: this.routeParamsFromHistory.subpath,
        },
      }
    },
    canRender() {
      return this.dynamicComponent && this.dynamicComponent.id && this.documentToBeRendered
    },
    renderedComponentKey() {
      const renderedDocumentId = this.documentToBeRendered && this.documentToBeRendered.id
      return `${this.dynamicComponent.id}:${renderedDocumentId || 'missing-document'}`
    },
    shouldRenderDeveloperFallback() {
      return this.Aeppic.Developer?.isEnabled === true
          && this.Aeppic.Developer?.showMissingDesignFallbacks === true
          && this.fallbackReason
          && this.fallbackReason !== 'loading'
    },
    configuredMissingDocumentLayoutId() {
      const layout = this.fallbackDesign?.data?.missingDocumentLayout

      return typeof layout === 'string' ? layout : layout?.id
    },
    missingDocumentLayoutId() {
      return this.missingDocLayoutId || this.configuredMissingDocumentLayoutId
    },
    _documentId() {
      return this.documentId || this.document && this.document.id
    }
  },
  mounted() {
    this.Aeppic.setContextRootElement(this.$el)
    document.addEventListener('ae-route-params-changed', this.onRouteParamsChanged, true)
  },
  updated() {
    this.Aeppic.setContextRootElement(this.$el)
  },
  created() {
    const Aeppic = this.Aeppic

    this.componentKey = Aeppic.uuid()

    const isDeveloper = Aeppic.Account && Aeppic.Account.data.allowDevMode

    const watch = typeof this.watchDesign === 'boolean' ? this.watchDesign : isDeveloper
    const watchRevisions =  Aeppic.Developer.isServerInRemoteDeveloperMode ? false
                          : typeof this.watchDesignRevisions === 'boolean' ? this.watchDesignRevisions
                          : isDeveloper

    this.createDynamicComponent = function () {
      return new DynamicComponent('design', this.Aeppic, {
        formId: 'design-form',
        template: COMPONENT_SOURCE_TEMPLATES.design,
        exposedSymbols: EXPOSED_SYMBOLS.design,
        watch,
        watchRevisions
      })
    }

    this.watcher = null

    if (this.params && Object.keys(this.params).length > 0) {
      // console.warn('Note: Please try to not use parameters on designs unless absolutely necessary.')
    }

    this.loadDocument = async function() {
      const useProvidedDocument = !this.watch ? true : this.documentToBeRendered === null

      if (useProvidedDocument && this.document && isDocument(this.document)) {
        this.loadedDocument = await this.document
      } else if (this._documentId) {
        this.loadedDocument = await this.Aeppic.get(this._documentId)
      } else {
        this.loadedDocument = null
      }

      return this.loadedDocument
    }    

    this.loadDesign = async function() {
      await perf.track('design:load', async () => {
      this.fallbackDesign = null
      this.fallbackReason = 'loading'

      if (this.name) {
        const documentToRender = await perf.track('design:document', () => this.loadDocument(), this.name || this._documentId || '')

        if (documentToRender) {
          const designDocument = await perf.track('design:find', () => this.Aeppic.Designs.findDesignForDocument(documentToRender, this.name), this.name)
          
          if (designDocument) {
            // Important: Change component id AND document to be rendered in
            // same tick to prevent mismatches.
            this.Aeppic.renameContext(`ae-design-selector{'${this.name}'}:${designDocument.id}:${designDocument.data.name}`)
            await this.dynamicComponent.refresh(designDocument, () => {
              this.documentToBeRendered = documentToRender
              this.renderedDocumentEditVersion = this.getRenderedDocumentEditVersion(documentToRender)
            })
            this.fallbackReason = null
          } else {
            this.Aeppic.renameContext(`ae-design-selector{'${this.name}'}:-`)
            this.fallbackReason = 'missing-design'
            this.documentToBeRendered = documentToRender
            this.renderedDocumentEditVersion = this.getRenderedDocumentEditVersion(documentToRender)
            this.dynamicComponent.reset()
          }
        } else {
          this.Aeppic.renameContext(`ae-design-selector{'${this.name}'}`)        
          this.fallbackReason = 'missing-document'
          this.documentToBeRendered = null
          this.renderedDocumentEditVersion = null
          this.dynamicComponent.reset()
          this.fallbackDesign = await perf.track('design:find', () => this.Aeppic.Designs.findFallbackDesign(this.name), this.name)
        }
      } else {        
        this.Aeppic.renameContext(`ae-design-selector`)        
        this.fallbackReason = 'missing-name'
        this.documentToBeRendered = null
        this.renderedDocumentEditVersion = null
        this.dynamicComponent.reset()
      }
      }, this.name || '')
    }

    this.dynamicComponent = this.createDynamicComponent()
    this.dynamicComponent.on('invalidated', () => this.loadDesign())
    
    this.loadDesign()
  },
  beforeDestroy() {
    document.removeEventListener('ae-route-params-changed', this.onRouteParamsChanged, true)
    this.stopWatchingEditContext()
    this.dynamicComponent.destroy()
    this.Aeppic.release()
  },
  methods: {
    onRouteParamsChanged(event) {
      const detail = event.detail || {}
      const routeParams = detail.routeParams || {}
      this.routeParamsFromHistory = {
        query: routeParams.query || {},
        subpath: routeParams.subpath || {},
      }
    },
    getRenderedDocumentEditVersion(document) {
      if (!document) {
        return null
      }

      const registry = this.Aeppic.EditContext?.Registry

      if (registry && registry.findTrackedDocument?.(document.id)) {
        return `${document.editVersion || document.v || 'tracked'}:${registry.changeToken}`
      }

      if (this.Aeppic.isEditableDocument(document)) {
        return document.editVersion
      }

      return document.v || null
    },
    startWatchingEditContext() {
      this.stopWatchingEditContext()

      const registry = this.Aeppic.EditContext?.Registry
      if (!registry || typeof registry.onChange !== 'function' || !this._documentId) {
        return
      }

      this.editContextWatcher = registry.onChange(() => this.refreshFromEditContext())
      this.refreshFromEditContext()
    },
    stopWatchingEditContext() {
      if (this.editContextWatcher) {
        this.editContextWatcher()
        this.editContextWatcher = null
      }
    },
    refreshFromEditContext() {
      const registry = this.Aeppic.EditContext?.Registry
      const documentId = this._documentId

      if (!registry || !documentId) {
        return
      }

      const trackedDocument = registry.findTrackedDocument(documentId)

      if (trackedDocument && trackedDocument !== this.documentToBeRendered) {
        const isSameForm = this.documentToBeRendered?.f?.id === trackedDocument.f?.id
        this.loadedDocument = trackedDocument
        this.documentToBeRendered = trackedDocument

        if (!isSameForm) {
          this.loadDesign()
          return
        }
      }

      const editVersion = this.getRenderedDocumentEditVersion(this.documentToBeRendered)
      if (editVersion !== this.renderedDocumentEditVersion) {
        this.renderedDocumentEditVersion = editVersion
      }
    },
    startWatchingDocument() {
      this.stopWatchingDocument()

      if (!this.watch || !this._documentId) {
        return
      }

      this.watcher = this.Aeppic.watch(this._documentId, onChange.bind(this))

      function onChange(changedDocument, reason) {
        if (reason.deletedHard) {
          this.documentToBeRendered = null

          return
        }

        if ((reason.updated || reason.stampChanged) && this.loadedDocument) {
          const isSameForm = this.loadedDocument.f.id === changedDocument.f.id 
          const isExactSameForm = isSameForm && this.loadedDocument.f.v === changedDocument.f.v

          if (this.Aeppic.isEditableDocument(this.loadedDocument)) {
            if (!isExactSameForm) {
              this.Aeppic.Log.debug({ target: this.loadedDocument, source: changedDocument }, 'Integrating document that is is not the same form version')
            }

            this.Aeppic.integrate(this.loadedDocument, changedDocument)

            if (!isSameForm) {
              this.loadDesign()
            }
          } else {
            this.documentToBeRendered = changedDocument
            this.loadDesign()
          }
        }
      }
    },
    stopWatchingDocument() {
      if (this.watcher) {
        this.watcher.stop()
        this.watcher = null
      }
    },
    hideComponent() {
      this.isComponentManuallyHidden = true
    },
    showComponent() {
      this.isComponentManuallyHidden = false
    },
    renderFallback(createElement) {
      const fallbackProps = {
        reason: this.fallbackReason,
        documentId: this._documentId,
        document: this.loadedDocument || this.document || (this._documentId ? { id: this._documentId } : null),
        name: this.name,
      }

      const reasonSlot = this.$scopedSlots[this.fallbackReason]

      if (reasonSlot) {
        return createElement('span', {
          staticClass: 'ae-design-fallback',
          attrs: {
            'data-ae-design-fallback-reason': this.fallbackReason || '',
          },
        }, reasonSlot(fallbackProps))
      }

      if (this.$slots[this.fallbackReason]) {
        return createElement('span', {
          staticClass: 'ae-design-fallback',
          attrs: {
            'data-ae-design-fallback-reason': this.fallbackReason || '',
          },
        }, this.$slots[this.fallbackReason])
      }

      // The default slot is resolved fallback content, not provisional content.
      // In document dialogs it can mount a full editable form.
      if (this.fallbackReason === 'loading') {
        return createElement('span', {
          staticClass: 'ae-design-fallback ae-design-fallback--loading',
          attrs: {
            'data-ae-design-fallback-reason': 'loading',
            'aria-busy': 'true',
          },
        })
      }

      if (this.$scopedSlots.default) {
        return createElement('span', {
          staticClass: 'ae-design-fallback',
          attrs: {
            'data-ae-design-fallback-reason': this.fallbackReason || '',
          },
        }, this.$scopedSlots.default(fallbackProps))
      }

      if (this.$slots.default) {
        return createElement('span', {
          staticClass: 'ae-design-fallback',
          attrs: {
            'data-ae-design-fallback-reason': this.fallbackReason || '',
          },
        }, this.$slots.default)
      }

      if (this.fallbackReason === 'missing-document' && this.missingDocumentLayoutId) {
        return createElement('ae-layout', {
          staticClass: 'ae-design-fallback ae-design-fallback--missing-document',
          attrs: {
            'data-ae-design-fallback-reason': this.fallbackReason,
          },
          props: {
            layoutId: this.missingDocumentLayoutId,
            params: {
              ...(this.params || {}),
              reason: this.fallbackReason,
              documentId: fallbackProps.documentId,
              document: fallbackProps.document,
              designName: this.name,
            },
          },
          on: createEventForwarders(this._events, this),
        })
      }

      if (this.shouldRenderDeveloperFallback) {
        const document = fallbackProps.document
        const formRef = document?.f
        const messageParts = [
          `ae-design: ${this.fallbackReason}`,
          `name="${this.name || ''}"`,
        ]

        if (fallbackProps.documentId) {
          messageParts.push(`document=${fallbackProps.documentId}`)
        }

        if (formRef?.id) {
          messageParts.push(`form=${formRef.id}${formRef.v ? '@' + formRef.v : ''}`)
        }

        return createElement('pre', {
          staticClass: 'ae-design-fallback ae-design-fallback--developer ae-error',
          attrs: {
            'data-ae-design-fallback-reason': this.fallbackReason || '',
            'data-ae-design-name': this.name || '',
            'data-ae-design-document-id': fallbackProps.documentId || '',
            'data-ae-design-form-id': formRef?.id || '',
          },
          style: {
            display: 'block',
            boxSizing: 'border-box',
            position: 'absolute',
            zIndex: '2147483647',
            maxWidth: 'min(32rem, calc(100vw - 1rem))',
            margin: '0.25rem',
            padding: '0.5rem 0.625rem',
            whiteSpace: 'pre-wrap',
            overflowWrap: 'anywhere',
            color: '#b42318',
            background: '#fff4f2',
            border: '1px solid #fda29b',
            borderRadius: '6px',
            boxShadow: '0 8px 24px rgba(15, 23, 42, 0.16)',
            fontSize: '12px',
            lineHeight: '1.35',
            pointerEvents: 'none',
          },
        }, messageParts.join('\n'))
      }

      return createElement()
    },
  },
  watch: {
    name(id) {
      this.loadDesign()
    },
    watch() {
      this.startWatchingDocument()
    },
    async document() {
      // do not re-create dynamicComponent when only document of same form is changed
      if (this.documentToBeRendered && (this.document || this.documentId)) {
        const newDocument = this.document && isDocument(this.document) ? this.document : await this.loadDocument()

        if (newDocument?.f.id === this.documentToBeRendered.f.id) {
          if (newDocument !== this.documentToBeRendered) {
            this.stopWatchingDocument()
            this.documentToBeRendered = newDocument 
          }

          return
        }
      }

      this.stopWatchingDocument()
      this.loadDesign()
    },
    documentId() {
      this.stopWatchingDocument()
      this.stopWatchingEditContext()
      this.loadDesign()
    },
    documentToBeRendered() {
      this.startWatchingDocument()
      this.startWatchingEditContext()
    }
  }
}
